module.exports = __webpack_public_path__ + "img/changer-lifestyle-after.8ba213ed.jpg";